import React from 'react';
import Link from 'components/Link';
import { Alert } from 'react-bootstrap';
import { useGlobalContext } from 'context/GlobalContext';
import { getPreferenceByGroup } from 'helpers/preferences';
import { useRouter } from 'next/router';

const EmailOptedOutAlert = () => {
    const { user } = useGlobalContext();
    const router = useRouter();
    const isPathnameSavedSearches = router.pathname === '/account/settings/saved-searches';

    if (!user?.preferences) {
        return null;
    }

    const hasMarketingEmailsEnabled = getPreferenceByGroup({
        preferences: user?.preferences,
        userPreferenceGroupId: 3,
        typeId: 0,
    })?.delivery?.email;

    if (!hasMarketingEmailsEnabled && isPathnameSavedSearches) {
        return (
            <Alert variant="warning">
                <strong className="notice">Attention Buyer:</strong>
                {' '}
                You’ve opted out of marketing and promotional emails. To receive Saved Search notifications, please
                enable Marketing Emails in your <Link to="/account/settings/notifications">Notification
                Settings</Link>.
            </Alert>
        );
    }
};

export default EmailOptedOutAlert;
